<template>
  <div class="password-change">
    <form @submit.prevent="changePassword()" class="password-change__form">
      <div class="password-change__field">
        <label for="password_actual" class="password-change__label">Contraseña Actual</label>
        <div class="control">
          <input type="password" id="password_actual" v-model="current" class="input password-change__input">
        </div>
      </div>
      <div class="password-change__field">
        <label for="nueva_contraseña" class="password-change__label">Nueva Contraseña</label>
        <div class="control">
          <input type="password" id="nueva_contraseña" v-model="newP" class="input password-change__input">
        </div>
      </div>
      <div class="password-change__field">
        <label for="confirmar_contraseña" class="password-change__label">Confirmar Nueva Contraseña</label>
        <div class="control">
          <input type="password" id="confirmar_contraseña" v-model="newConfirm" class="input password-change__input">
        </div>
      </div>
      <button type="submit" class="button password-change__submit">Cambiar Contraseña</button>
    </form>
    <p v-if="mensaje" class="password-change__message password-change__message--error">{{ mensaje }}</p>
    <p v-if="mensaje2" class="password-change__message password-change__message--success">{{ mensaje2 }}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      current: '',
      newP: '',
      newConfirm: '',
      mensaje: '',
      mensaje2: ''
    }
  },
  methods: {
    changePassword () {
      if (this.newP !== this.newConfirm) {
        this.mensaje2 = ''
        this.mensaje = 'Las contraseñas no coinciden.'
        return
      }
      this.mensaje = ''
      this.mensaje2 = ''
      this.$axios
        .post('changePassword', { user: { current: this.current, new: this.newP } })
        .then(response => {
          console.log(response)
          if (response.data.result) {
            this.mensaje2 = 'Se ha cambiado la contraseña'
          } else {
            this.mensaje = 'No puedes cambiar esta contraseña'
          }
        })
        .catch(error => console.log(error))
      this.current = ''
      this.newP = ''
      this.newConfirm = ''
    }
  }
}
</script>

<style scoped>
.password-change {
  width: 100%;
}

.password-change__form {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.password-change__field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.password-change__label {
  margin: 0;
  color: #4b3d30;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
}

.password-change__input {
  min-height: 3.1rem;
  border: 1px solid rgba(102, 82, 60, 0.12);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.96);
}

.password-change__input:focus {
  border-color: rgba(98, 74, 45, 0.28);
  box-shadow: 0 0 0 0.125em rgba(146, 118, 84, 0.14);
}

.password-change__submit {
  align-self: flex-start;
  min-height: 3rem;
  margin-top: 0.35rem;
  padding: 0 1.2rem;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #201a14, #4c3b2b);
  color: #fff7ef;
  box-shadow: 0 14px 30px rgba(42, 30, 18, 0.18);
}

.password-change__submit:hover,
.password-change__submit:focus {
  color: #fff7ef;
}

.password-change__message {
  margin: 0.9rem 0 0;
  padding: 0.8rem 1rem;
  border-radius: 16px;
  font-size: 0.92rem;
}

.password-change__message--error {
  background: rgba(185, 92, 92, 0.12);
  color: #8f4040;
}

.password-change__message--success {
  background: rgba(96, 131, 104, 0.13);
  color: #47664e;
}

@media (max-width: 640px) {
  .password-change__submit {
    width: 100%;
  }
}
</style>
